import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatNumber } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  ordered_speed_kts: 12,
  speed_through_water_kts: 11.9,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  const threshold = Number(metadata["ordered_speed_kts"]);
  const actual = Number(metadata["speed_through_water_kts"]);

  if (isNaN(actual) || isNaN(threshold)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const data = [
    {
      name: "Reported average STW",
      mobileName: "Label 1",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = 0.2 * actual;
  const domainMax =
    actual < threshold
      ? Math.ceil((threshold + margin) / 10) * 10
      : Math.ceil((actual + margin) / 10) * 10;
  const domain = [domainMin, domainMax];

  const mobileMargin = actual < threshold ? 0.1 * threshold : 0.1 * actual;
  const mobileDomainMax =
    actual < threshold
      ? Math.ceil(threshold + mobileMargin)
      : Math.ceil(actual + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const numOfTicks =
    actual > threshold ? Math.floor(actual / 5) : Math.floor(threshold / 5);

  const ticks = [];
  // add 1 for 0 and 1 for the extra margin
  for (let i = 0; i < numOfTicks + 2; i++) {
    ticks.push(5 * i);
  }

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Instructed speed${
        !isExample
          ? ` (${formatNumber(threshold, {
              precision: 1,
              unit: "knots",
              options: { boundaryValues: [0, actual] },
            })})`
          : ""
      }`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < threshold}
      unitOfMeasure={"knots"}
      axisLabel={"Speed through water"}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${formatNumber(value, { precision: 1, unit: "knots", options: { boundaryValues: [0, threshold] } })}`
      }
      ticks={ticks}
      isExample={isExample}
    />
  );
}
